export default __webpack_public_path__ + "static/media/loaderNew.350e404e.gif";